<footer>
  <div class="footer-logo-container">
    <div class="logo-content">
      <a href="https://www.symetra.com" class="footer-logo" target="blank">
        <img src="/assets/images/footer-logo.svg" alt="symetra logo" />
      </a>
      <div class="desktop-spacer"></div>
      <span class="social-media">Connect with us</span>
      <div class="mobile-spacer"></div>
        <a *ngFor="let item of socialMediaContent" [href]="item.url" [attr.aria-label]="item.name" class="social-icon" target="blank">
          <dxo-social-icon [socialMedia]="item.name" [fontSize]="24" color="currentColor"></dxo-social-icon>
        </a>
    </div>
  </div>
  <div class="footer-links-container">
    <div class="general-header">{{header}}</div>
    <div class="contact-container">
      <div class="links">
        <a
        [href]="emailLink"
        target="blank"
        >{{emailText}}</a>
      </div>
      <div class="divider">|</div>
      <div class="links">
        <a href="tel:{{ contactInfo.tel }}" class="phone">{{ contactInfo.tel }}</a>
      </div>
    </div>
      <div class="hours">{{ contactInfo.hours }}</div>

        <div class="multi-link-container">
            <div class="multi-link-item" *ngFor="let item of content index as i">
              <a target="blank" [href]="item.url">{{ item.name }}</a>
              <div *ngIf="i !== 6" class="multi-link-divider">|</div>
            </div>
        </div>
        
        <div class="legal-container">
          <address class="legal">
            Copyright &copy; 2004 - {{ currentYear }} Symetra Life Insurance Company, 777 108th Ave NE, Suite 1200, Bellevue,
            WA 98004. All rights reserved. Symetra® is a registered service mark of Symetra Life Insurance Company.
          </address>
        </div>
      </div>
</footer>
